export enum ChatCardState {
  Hidden = 'HIDDEN',
  Showing = 'SHOWING',
  Visible = 'VISIBLE',
}
